import { DeviceProfileData } from "../../../constants/manage-device-profile-data";
import { makeDeviceTypeListGroupsComponent } from "../Lists/DeviceProfileListGroups";

export const DeviceTypeListGroups = makeDeviceTypeListGroupsComponent<DeviceProfileData>();
